module.exports = __webpack_public_path__ + "img/sharedbg.0d2d9611.png";